// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.54 8.07H5.55M7.97 8.07H7.98M10.41 8.06H10.42M5.53 4.95H5.54M7.98 4.95H7.99M10.41 4.95H10.42M6 10.91H6.6M6.6 10.91H9.4M6.6 10.91V14M9.4 10.91H10M9.4 10.91V14M9.4 14H6.6L4 14C3.45 14 3 13.55 3 13V4C3 2.89 3.9 2 5 2L11 2C12.1 2 13 2.9 13 4V13C13 13.55 12.55 14 12 14L9.4 14Z',
];
